import { ServerResponse } from './responses';

export type Subscription = {
  code: string;
  plan_code: string;
  duration: number;
  source: string;
  start_date: string;
  end_date: string;
  next_billing_date: string;
  last_billing_date: string;
  amount: number;
  is_auto_renewal: boolean;
  state: SubscriptionStates;
};

export enum SubscriptionStates {
  enabled = 'enabled',
  cancelled = 'cancelled',
  payment_failed = 'payment_failed',
  paid = 'paid',
  subscription_requested = 'subscription_requested',
  renewal_requested = 'renewal_requested',
  voucher_requested = 'voucher_requested',
  voucher_failed = 'voucher_failed',
  validation_failed = 'validation_failed',
  expired = 'expired'
}

export type SubscriptionPlan = {
  code: string;
  corporate: boolean;
  enabled: boolean;
  tiers: SubscriptionTier[];
};

export type SubscriptionTier = {
  billed_price: number;
  billed_promo_price: number;
  duration_months: number;
  monthly_price: number;
  monthly_promo_price: number;
  recommended: boolean;
  savings_value: number;
  title: string;
};

/** Subscription Service Types */

export enum SubscriptionAction {
  Plans = 'plans',
  BulkSubscribe = 'bulk-subscribe',
  BulkUnsubscribe = 'bulk-unsubscribe'
}

/** Subscription Response types */

interface SubscribePayload {
  plan_code: string;
  tier_duration: number;
}

interface UserSubscribePayload extends SubscribePayload {
  users: number[];
}

interface DepartmentSubscribePayload extends SubscribePayload {
  departments: number[];
}

interface SubscribedUsersResponse {
  customer_code: string;
  status: string;
  subscription_code: string;
}

interface UnsubscribedUserResponse {
  code: string;
  customer_code: string;
  start_date: string;
  end_date: string;
  plan_code: string;
  status: string;
}

export interface SubscriptionListResponse extends ServerResponse {
  data: SubscriptionPlan[];
}

export type BulkSubscribePayload =
  | UserSubscribePayload
  | DepartmentSubscribePayload;

export interface BulkSubscribeResponse extends ServerResponse {
  data: {
    customers_fail: SubscribedUsersResponse[];
    customers_success: SubscribedUsersResponse[];
    plan_code: string;
    tier_duration: number;
    total: number;
  };
}

export interface BulkUnsubscribePayload {
  users: number[];
}

export interface BulkUnsubscribeResponse extends ServerResponse {
  data: {
    plan_code: string;
    success: boolean;
    total: number;
    cancelled_subscriptions: UnsubscribedUserResponse[];
  };
}
